import { TransactionDelegate, TransactionStatus } from '@/features/Transactions/transactions.types'
import React from 'react'
import { TransactionRow } from '../Common/TransactionRow'

export function Delegate({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionDelegate;
  withoutDate: boolean;
}) {
  return (
    <TransactionRow
      amount={transaction.data.cryptoAmount}
      createdAt={transaction.createdAt}
      iconType="APPROVE_DELEGATE"
      isError={transaction.status === TransactionStatus.ERROR_SEND}
      onClick={onClick}
      status={transaction.status}
      title="Delegation"
      type={null}
      withoutDate={withoutDate}
    />
  )
}
